var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMoney(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2855_32916",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 17
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 16,
    height: 16,
    fill: "#C4C4C4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2855_32916)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.66667 10.5C2.66667 9.764 2.06933 9.16667 1.33333 9.16667V5.16667C2.06933 5.16667 2.66667 4.56933 2.66667 3.83333H10.6667C10.6667 4.56933 11.264 5.16667 12 5.16667V9.16667C11.264 9.16667 10.6667 9.764 10.6667 10.5H2.66667ZM12.6667 11.8333C13.0347 11.8333 13.3333 11.5347 13.3333 11.1667V3.16667C13.3333 2.79867 13.0347 2.5 12.6667 2.5H0.666667C0.298 2.5 0 2.79867 0 3.16667V11.1667C0 11.5347 0.298 11.8333 0.666667 11.8333H12.6667ZM6.66667 5.16667C5.562 5.16667 4.66667 6.062 4.66667 7.16667C4.66667 8.27133 5.562 9.16667 6.66667 9.16667C7.77067 9.16667 8.66667 8.27133 8.66667 7.16667C8.66667 6.062 7.77067 5.16667 6.66667 5.16667ZM15.3333 5.16667H14.6667V7.83333V11.8333V12.5C14.6667 12.8687 14.368 13.1667 14 13.1667H13.3333H5.33333H2.66667V13.8333C2.66667 14.202 2.96467 14.5 3.33333 14.5H15.3333C15.7013 14.5 16 14.202 16 13.8333V5.83333C16 5.46533 15.7013 5.16667 15.3333 5.16667Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoney);
export default __webpack_public_path__ + "static/media/money.27e1c675e48286cd1be221ffe490b670.svg";
export { ForwardRef as ReactComponent };